import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "inst-title" }, "재료 소모량 최적화 검사", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, "3D모델의 크기에 비해 부피가 매우 높게 측정됩니다\n제작은 가능하나 아래의 방법으로 효율적인 생산을 권장드립니다.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "inst-subtitle" }, "[해결방법]", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", { class: "inst-desc" }, [
  /*#__PURE__*/_createTextVNode("· 내부비움으로 최적화 권장"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("· 모델 내부 구조 변경 으로 최적화 권장")
], -1)
const _hoisted_5 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _hoisted_5))
}